import { Link } from 'react-router-dom';
import { categories, novels } from '@/mocks/novels';

const colorMap: Record<string, { bubble: string; icon: string }> = {
  primary: { bubble: 'bg-primary-100 text-primary-600', icon: 'text-primary-500' },
  accent: { bubble: 'bg-accent-100 text-accent-600', icon: 'text-accent-500' },
  secondary: { bubble: 'bg-secondary-100 text-secondary-600', icon: 'text-secondary-500' },
};

export default function CategoryGrid() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-8 md:py-16">
      <div className="mb-7 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            分类快捷入口
          </h2>
          <p className="mt-2 text-sm text-foreground-500">挑一个感兴趣的题材，马上开始探索</p>
        </div>
        <Link
          to="/category"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 sm:inline-flex"
        >
          查看全部书库
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {categories.map((c) => {
          const count = novels.filter((n) => n.category === c.name).length;
          const tone = colorMap[c.color] ?? colorMap.primary;
          return (
            <Link
              key={c.name}
              to={`/category?cat=${encodeURIComponent(c.name)}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg ${tone.bubble}`}
              >
                <i className={`${c.icon} text-2xl`}></i>
              </span>
              <span className="mt-4 text-base font-semibold text-foreground-950 group-hover:text-primary-600">
                {c.name}小说
              </span>
              <span className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-500">
                {c.desc}
              </span>
              <span className="mt-3 text-xs text-foreground-400">{count} 本在架</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}